import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { shema } from '../lib';
import { useGroup } from '@entities/common/groups';
import type { Group } from '@shared/types/common';


export const useEditorForm = (groupId: number) => {

	const { group } = useGroup(groupId);
	
	const defaultFormState = {
		name: '',
	};

	const { register, reset, watch, getValues, setValue, control, ...methods } = useForm<Group>({
		resolver: yupResolver((shema) as any),
		defaultValues: { ...defaultFormState },
	});

	const hasDirtyFields = () => {
		const {
			formState: { dirtyFields },
		} = { ...methods };

		return Object.keys(dirtyFields).length > 0;
	};


	useEffect(() => {
		let savedStateParsed = null;
		const savedState = localStorage.getItem('groupEditorFormState');
		if (savedState) {
			savedStateParsed = JSON.parse(savedState);
		}

		if (group) {
			const formState = {
				name: savedStateParsed ? savedStateParsed.name : group.name,
	
				photo: savedStateParsed ? savedStateParsed.photo : group.photo,
			};
			// console.log('Есть группа и мы ее редактируем', formState);

			reset(formState);
		} else if (savedStateParsed) {
			// console.log('Вернулись на форму');

			reset({ ...savedStateParsed });
			localStorage.removeItem('groupEditorFormState');
		}
	}, [group, reset]);


	return {
		methods: { register, reset, watch, getValues, setValue, control, ...methods },
		hasDirtyFields: hasDirtyFields(),
	};
};
